import { render, staticRenderFns } from "./classifylist.vue?vue&type=template&id=7ef1f2d4&"
import script from "./classifylist.vue?vue&type=script&lang=js&"
export * from "./classifylist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports